import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getWeddingPageByTypeV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import Map from '../../common/ui/Map';
import { chunkArray } from '../../common/ui/templateHelpers';
import Address from '../../common/ui/Address';

class Poi extends Component {
  constructor(props) {
    super(props);
    this.getMarkers = this.getMarkers.bind(this);
  }

  componentDidMount() {
    const { getPoiEntities, forPreview } = this.props;
    if (!forPreview) {
      getPoiEntities();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  getMarkers() {
    const { pois, orderedIds, forPreview } = this.props;
    const markers = [];
    if (forPreview) {
      orderedIds.forEach((id) => {
        if (pois[id].latitude) {
          markers.push({ position: { lat: parseFloat(pois[id].latitude), lng: parseFloat(pois[id].longitude) }, title: pois[id].title });
        }
      });
    } else {
      pois.forEach((poi) => {
        if (poi.latitude) {
          markers.push({ position: { lat: parseFloat(poi.latitude), lng: parseFloat(poi.longitude) }, title: poi.title });
        }
      });
    }
    return markers;
  }

  render() {
    const { pois, orderedIds, forPreview, page, theme, showMap, busy, wedding } = this.props;
    let markers;
    if (!busy && pois) {
      markers = this.getMarkers();
    }

    return (
      <div id="poi-page" className="container">
        {page && !busy && (
          <div className={['cms-page-header', ((!page.description && !page.header_image_url) ? 'flex-container' : null)].join(' ')}>
            <div className="cms-header-accent-top-left" />
            <div className="cms-header-accent-top-right" />
            <div className="cms-header-accent-bottom-left" />
            <div className="cms-header-accent-bottom-right" />
            <h1 className="for-small-laptops">{page.title}</h1>
            {page.header_image_url && (
              <img src={`${page.header_image_url}?h=400`} alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} className="img-responsive center-block" />
            )}
            {page.description && (
              <p className={['page-description', (page.header_image_url ? 'has-image-above' : null)].join(' ')}>{page.description}</p>
            )}
          </div>
        )}
        {markers && markers.length > 0 && showMap && (
          <div className="map-container">
            <Map markers={markers} theme={{ styles: theme.map_style, pin: theme.map_pin }} />
          </div>
        )}
        <div className="entity-sections poi-sections">
          <div className="entity-sections-accent-top-left" />
          <div className="entity-sections-accent-top-right" />
          <div className="entity-sections-accent-bottom-left" />
          <div className="entity-sections-accent-bottom-right" />
          {forPreview && pois && chunkArray(orderedIds, 2).map((poiIdChunk, idx) => (
            <div className="entity-section-row" key={idx}>
              {poiIdChunk.map(poiId => (
                <div className="entity-section poi-section" key={poiId}>
                  <div className="entity-section-title poi-section-title">
                    {pois[poiId].image_url && (
                      <div className="poi-photo-wrapper">
                        <div className="poi-photo" style={{ backgroundImage: !pois[poiId].image_id ? `url(${pois[poiId].image_url})` : `url(${pois[poiId].image_url}?h=400)` }} />
                      </div>
                    )}
                    <h2 className="poi-title">{pois[poiId].title}</h2>
                    <Address
                      address1={pois[poiId].address_1}
                      address2={pois[poiId].address_2}
                      city={pois[poiId].city}
                      state={pois[poiId].state_province}
                      zip={pois[poiId].postal_code}
                      countryCode={pois[poiId].country_code}
                    />
                    {pois[poiId].contact_phone && (
                      <p>{pois[poiId].contact_phone}</p>
                    )}
                  </div>
                  <div className="entity-section-description poi-section-description">
                    {pois[poiId].description && (
                      <p>
                        {pois[poiId].description}
                      </p>
                    )}
                    {pois[poiId].url && (
                      <button className="btn btn-primary btn-wide">View</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
          {!forPreview && pois && chunkArray(pois, 2).map((poiChunk, idx) => (
            <div className="entity-section-row" key={idx}>
              {poiChunk.map((poi, i) => (
                <div className="entity-section poi-section" key={i}>
                  <div className="entity-section-title poi-section-title">
                    {poi.image_url && poi.url && (
                      <a href={poi.url} className="block-link" target="_blank" rel="noopener noreferrer">
                        <div className="poi-photo-wrapper">
                          <div className="poi-photo" style={{ backgroundImage: !poi.image_id ? `url(${poi.image_url})` : `url(${poi.image_url}?h=400)` }} />
                        </div>
                      </a>
                    )}
                    {poi.image_url && !poi.url && (
                      <div className="poi-photo-wrapper">
                        <div className="poi-photo" style={{ backgroundImage: !poi.image_id ? `url(${poi.image_url})` : `url(${poi.image_url}?h=400)` }} />
                      </div>
                    )}
                    <h2 className="poi-title">
                      {poi.url && (
                        <a href={poi.url} target="_blank" rel="noopener noreferrer">{poi.title}</a>
                      )}
                      {!poi.url && (
                        poi.title
                      )}
                    </h2>
                    <Address
                      address1={poi.address_1}
                      address2={poi.address_2}
                      city={poi.city}
                      state={poi.state_province}
                      zip={poi.postal_code}
                      countryCode={poi.country_code}
                    />
                    {poi.contact_phone && (
                      <p className="poi-description">{poi.contact_phone}</p>
                    )}
                  </div>
                  <div className="entity-section-description poi-section-description">
                    {poi.description && (
                      <p className="poi-description">
                        {poi.description}
                      </p>
                    )}
                    {poi.url && (
                      <a href={poi.url} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-wide">View</a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
          {((forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && pois && pois.length === 0)) && (
            <p className="text-center empty-entity-text">
              We&#39;re making a list of our favorite activities and sights in the area. Check back soon.
            </p>
          )}
        </div>
      </div>
    );
  }
}

Poi.propTypes = {
  pois: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({}))
  ]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getPoiEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({
    title: PropTypes.string,
    header_image_url: PropTypes.string,
    description: PropTypes.string,
  }),
  theme: PropTypes.shape({
    map_style: PropTypes.string,
    map_pin: PropTypes.string,
  }),
  showMap: PropTypes.bool,
  busy: PropTypes.bool,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
  })
};

const mapStateToProps = (state, ownProps) => (
  {
    pois: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
    orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
    page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
    theme: ownProps.forPreview ? state.wedding.theme : state.publicWebsite.theme,
    showMap: ownProps.forPreview ? state.wedding.account.enable_poi_maps : state.publicWebsite.wedding.enable_poi_maps,
    busy: state.publicWebsite.busy,
    wedding: state.publicWebsite.wedding
  }
);

const mapDispatchToProps = dispatch => (
  {
    getPoiEntities: () => {
      dispatch(getWeddingPageByTypeV2('things_to_do'));
    },
    unloadEntities: () => dispatch(resetEntities())
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(Poi);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Poi.jsx